import { render } from "./BaseCheckbox.vue?vue&type=template&id=3d9038e8"
import script from "./BaseCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=3d9038e8&lang=scss"
script.render = render

export default script